// extracted by mini-css-extract-plugin
module.exports = {"element":"styles_element__9OeKm","element_header":"styles_element_header__4_cfm","element_body":"styles_element_body__Rq5iC"};